const perPageDataArray = [5, 10, 20, 50, 100];
const defaultPerPageValue = 10;

export { perPageDataArray, defaultPerPageValue };
